


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Patient } from "@/api/model";

@Component({
  components: {}
})
export default class PatientHeader extends Vue {
  @Prop({
    required: true
  })
  public patient!: Patient;
}
